<div
    class="abgang-tier-eingabe"
    [class.abgang-tier-eingabe--compact]="compact"
    [class.abgang-tier-eingabe--stepper-layout]="stepperLayout"
>
    <div class="abgang-tier-eingabe__primary">
        <p *ngIf="!compact" class="abgang-tier-eingabe__hint">{{ restrictToGruppeHint }}</p>
        <p *ngIf="compact" class="abgang-tier-eingabe__hint abgang-tier-eingabe__hint--compact">{{ restrictToGruppeHint }}</p>

        <mat-form-field class="abgang-tier-eingabe__field" appearance="outline">
            <mat-label>{{ eingabeLabel }}</mat-label>
            <input
                #tierEingabeInput="matInput"
                matInput
                type="text"
                inputmode="numeric"
                [formControl]="eingabeCtrl"
                [maxlength]="maxLengthEingabe"
                (keydown.enter)="onEingabeEnter($event)"
            />
            <span matSuffix class="abgang-tier-eingabe__suffix">{{ numbers.length }}/{{ maxLengthEingabe }}</span>
            <button
                mat-icon-button
                matSuffix
                type="button"
                *ngIf="canConfirmEingabe"
                (click)="addOhrmarkePass($event)"
            >
                <mat-icon>check</mat-icon>
            </button>
        </mat-form-field>

        <div class="abgang-tier-eingabe__actions-row">
            <button
                *ngIf="showAlleTiereButton"
                mat-stroked-button
                type="button"
                color="primary"
                class="abgang-tier-eingabe__alle-tiere-btn"
                (click)="ladeAlleTiere()"
            >
                Alle Tiere laden ({{ tierPageSize }})
            </button>

            <kiene-gruppe-tier-filter-button
                *ngIf="canShowTierFilterButton"
                [gruppe]="filterDialogGruppe!"
                [gruppeIds]="filterGruppeIdsForDialog"
                [tierFilterSettings]="filterSettings"
                [respectFilterSettingsVisibility]="true"
                [disableTierFilterSelection]="true"
                (filterSelected)="onTierFilterSelected($event)"
            >
            </kiene-gruppe-tier-filter-button>

            <div class="abgang-tier-eingabe__gewicht-toggle">
                <mat-slide-toggle [formControl]="mitGewichtToggleCtrl"></mat-slide-toggle>
                <span class="abgang-tier-eingabe__gewicht-toggle-label" (click)="toggleMitGewicht()">
                    Mit Gewicht oder Abteil
                </span>
            </div>
        </div>
    </div>

    <section class="abgang-tier-eingabe__suche" *ngIf="isTeilOhrmarkeSuche">
        <div class="one-row abgang-tier-eingabe__preview">
            <span class="spacer"></span>
            <p
                class="abgang-tier-eingabe__preview-digits"
                [style.color]="checkBorderColor"
                [style.fontWeight]="checkBorderColor === 'green' || checkBorderColor === 'red' ? 'bold' : 'normal'"
                [style.fontSize]="fontSize"
            >
                {{ numbers }}
            </p>
            <span class="spacer"></span>
        </div>
        <div class="one-row abgang-tier-eingabe__preview-meta">
            <span class="spacer"></span>
            <div class="abgang-tier-eingabe__preview-meta-inner">
                <span *ngIf="ohrmarken.length > 0 && !ohrmarkeGefunden"
                    >{{ ohrmarken.length }} Tiere (letzte 5 Ziffern)</span
                >
                <span *ngIf="ohrmarkeGefunden">{{ getFirstTenDigits(ohrmarke) }}</span>
                <span *ngIf="ohrmarkeGefunden" class="abgang-tier-eingabe__preview-meta-bold">{{
                    getLastFiveDigits(ohrmarke)
                }}</span>
                <span *ngIf="keinErgebnis && ohrmarken.length === 0" class="abgang-tier-eingabe__preview-meta--fehler">
                    Kein Tier (letzte 5 Ziffern)
                </span>
                <span *ngIf="ohrmarkenAlle.length > 0" class="abgang-tier-eingabe__preview-meta--weitere">
                    {{ ohrmarkenAlle.length }} weitere Treffer
                </span>
            </div>
            <span class="spacer"></span>
        </div>
    </section>

    <div
        class="abgang-tier-eingabe__lists-panel"
        [class.abgang-tier-eingabe__lists-panel--scans-only]="!showGruppenTiereListe"
        [class.abgang-tier-eingabe__lists-panel--unified-empty]="showUnifiedListsEmpty"
    >
        <div *ngIf="showUnifiedListsEmpty" class="abgang-tier-eingabe__lists-empty" data-cy="abgang-tier-eingabe-lists-empty">
            <mat-icon>qr_code_scanner</mat-icon>
            <p class="abgang-tier-eingabe__lists-empty-title">Noch keine Tiere</p>
            <p class="abgang-tier-eingabe__lists-empty-hint">
                Ohrmarke oder Pass scannen, um Tiere zur Liste hinzuzuf&uuml;gen.
                <span *ngIf="showAlleTiereButton"> Alternativ &bdquo;Alle Tiere laden&ldquo; nutzen.</span>
            </p>
            <button
                *ngIf="showAlleTiereZurListeButton"
                type="button"
                mat-stroked-button
                color="accent"
                class="abgang-tier-eingabe__lists-head-btn"
                data-cy="abgang-alle-tiere-zur-liste"
                [disabled]="!canAlleTiereZurListeHinzufuegen || alleTiereZurListeLaeuft"
                (click)="alleTiereZurAbgangslisteHinzufuegen()"
            >
                <mat-icon>playlist_add</mat-icon>
                Alle {{ alleTiereZurListeCount }} Tiere zur Liste hinzuf&uuml;gen
            </button>
        </div>

        <div *ngIf="!showUnifiedListsEmpty" class="abgang-tier-eingabe__lists-header-row">
            <header *ngIf="showGruppenTiereListe" class="abgang-tier-eingabe__lists-col-head abgang-tier-eingabe__lists-col-head--tiere">
                <div class="abgang-tier-eingabe__tier-head-row">
                    <h3 class="abgang-tier-eingabe__lists-col-title">{{ tierListenColTitle }}</h3>
                    <button
                        *ngIf="showAlleTiereZurListeButton"
                        type="button"
                        mat-stroked-button
                        color="accent"
                        class="abgang-tier-eingabe__lists-head-btn"
                        data-cy="abgang-alle-tiere-zur-liste"
                        [disabled]="!canAlleTiereZurListeHinzufuegen || alleTiereZurListeLaeuft"
                        (click)="alleTiereZurAbgangslisteHinzufuegen()"
                    >
                        <mat-icon>playlist_add</mat-icon>
                        Alle {{ alleTiereZurListeCount }} Tiere zur Liste hinzuf&uuml;gen
                    </button>
                </div>
                <p
                    *ngIf="gruppenTiereLaden || gruppenTiereSucheLaeuft"
                    class="abgang-tier-eingabe__lists-col-status"
                >
                    {{ gruppenTiereLaden ? 'Tiere werden geladen…' : 'Suche…' }}
                </p>
            </header>
            <header class="abgang-tier-eingabe__lists-col-head abgang-tier-eingabe__lists-col-head--scans">
                <div class="abgang-tier-eingabe__scans-head-row">
                    <h3 class="abgang-tier-eingabe__lists-col-title">
                        Zuletzt gescannt
                        <span
                            *ngIf="!tierlisteTiereLaden && tierlisteTiereAnzeigeCount > 0"
                            class="abgang-tier-eingabe__lists-col-count"
                        >
                            ({{ tierlisteTiereAnzeigeCount }})
                        </span>
                    </h3>
                    <button
                        *ngIf="showAbgangslisteLeerenButton"
                        type="button"
                        mat-stroked-button
                        color="accent"
                        class="abgang-tier-eingabe__lists-head-btn abgang-tier-eingabe__lists-head-btn--warn"
                        data-cy="abgang-abgangsliste-leeren"
                        [disabled]="!canAbgangslisteLeeren || tierlisteTiereLaden"
                        (click)="abgangslisteLeeren()"
                    >
                        <mat-icon>delete_outline</mat-icon>
                        Liste leeren
                    </button>
                </div>
                <p *ngIf="tierlisteTiereLaden" class="abgang-tier-eingabe__lists-col-status">Liste wird geladen&hellip;</p>
            </header>
        </div>

        <div *ngIf="!showUnifiedListsEmpty" class="abgang-tier-eingabe__lists-body-row">
        <section class="abgang-tier-eingabe__tier-liste" *ngIf="showGruppenTiereListe">

        <ng-template #tierRow let-tier="tier">
            <button
                type="button"
                class="abgang-tier-eingabe__tier-row"
                [class.abgang-tier-eingabe__tier-row--on-list]="isTierAufAktuellerListe(tier)"
                (click)="tierListeAktion(tier, $event)"
            >
                <div class="abgang-tier-eingabe__tier-row-main">
                    <kiene-ohrmarke
                        [ohrmarke]="tier.ohrmarke_notnull || tier.ohrmarke_kurz || tier.ohrmarke15"
                        class="abgang-tier-eingabe__tier-row-ohrmarke"
                    ></kiene-ohrmarke>
                    <span *ngIf="getTierZusatzInfo(tier) as tierZusatz" class="abgang-tier-eingabe__tier-row-meta">{{
                        tierZusatz
                    }}</span>
                </div>
                <mat-icon class="abgang-tier-eingabe__tier-row-icon">{{
                    isTierAufAktuellerListe(tier) ? 'remove_circle' : 'add_circle'
                }}</mat-icon>
            </button>
        </ng-template>

        <p
            *ngIf="
                !gruppenTiereLaden &&
                !gruppenTiereSucheLaeuft &&
                numbers.length === 0 &&
                tierListeModus === 'alle' &&
                anzeigeTiere.length === 0
            "
            class="abgang-tier-eingabe__tier-liste-hint abgang-tier-eingabe__tier-liste-hint--leer"
        >
            Keine Tiere in den gewählten Gruppen gefunden.
        </p>

        <div
            *ngIf="!gruppenTiereLaden && !gruppenTiereSucheLaeuft && numbers.length === 0 && anzeigeTiere.length > 0"
            class="abgang-tier-eingabe__tier-liste-scroll"
        >
            <ng-container *ngFor="let tier of anzeigeTiere; trackBy: trackTierByGtId">
                <ng-container *ngTemplateOutlet="tierRow; context: { tier: tier }"></ng-container>
            </ng-container>
        </div>

        <ng-container *ngIf="!gruppenTiereLaden && !gruppenTiereSucheLaeuft && isTeilOhrmarkeSuche">
            <h4 class="abgang-tier-eingabe__tier-liste-title">Letzte 5 Ziffern</h4>
            <div *ngIf="ohrmarken.length > 0" class="abgang-tier-eingabe__tier-liste-scroll">
                <ng-container *ngFor="let tier of ohrmarken; trackBy: trackTierByGtId">
                    <ng-container *ngTemplateOutlet="tierRow; context: { tier: tier }"></ng-container>
                </ng-container>
            </div>
            <p *ngIf="ohrmarken.length === 0" class="abgang-tier-eingabe__tier-liste-hint abgang-tier-eingabe__tier-liste-hint--leer">
                Kein Treffer in den letzten 5 Ziffern
            </p>

            <h4 *ngIf="ohrmarkenAlle.length > 0" class="abgang-tier-eingabe__tier-liste-title">Weitere Treffer</h4>
            <div *ngIf="ohrmarkenAlle.length > 0" class="abgang-tier-eingabe__tier-liste-scroll">
                <ng-container *ngFor="let tier of ohrmarkenAlle; trackBy: trackTierByGtId">
                    <ng-container *ngTemplateOutlet="tierRow; context: { tier: tier }"></ng-container>
                </ng-container>
            </div>
        </ng-container>

        <div
            *ngIf="!gruppenTiereLaden && !gruppenTiereSucheLaeuft && numbers.length >= 10 && anzeigeTiere.length > 0"
            class="abgang-tier-eingabe__tier-liste-scroll"
        >
            <ng-container *ngFor="let tier of anzeigeTiere; trackBy: trackTierByGtId">
                <ng-container *ngTemplateOutlet="tierRow; context: { tier: tier }"></ng-container>
            </ng-container>
        </div>

        <button
            *ngIf="tierHasMore && !gruppenTiereLaden && !gruppenTiereSucheLaeuft"
            mat-stroked-button
            type="button"
            class="abgang-tier-eingabe__mehr-btn"
            [disabled]="tierLoadMoreRunning"
            (click)="ladeWeitereTiere()"
        >
            {{ tierLoadMoreRunning ? 'Lädt…' : 'Weitere ' + tierPageSize + ' laden' }}
        </button>
        </section>

        <aside
            class="abgang-tier-eingabe__scans"
            [class.abgang-tier-eingabe__scans--loading]="tierlisteTiereLaden"
            [class.abgang-tier-eingabe__scans--empty]="!tierlisteTiereLaden && tierlisteTiere.length < 1"
            id="gescannteOhrenmarken"
            data-cy="abgang-tierliste-tiere-laden"
        >
            <div *ngIf="tierlisteTiereLaden" class="abgang-tier-eingabe__scans-loading">
                <mat-spinner diameter="28" color="accent"></mat-spinner>
                <p class="abgang-tier-eingabe__scans-loading-text">Liste wird geladen&hellip;</p>
            </div>
            <p *ngIf="!tierlisteTiereLaden && tierlisteTiere.length < 1" class="abgang-tier-eingabe__scans-empty">
                Noch keine Tiere in der Liste
            </p>
            <ul *ngIf="!tierlisteTiereLaden && tierlisteTiere.length > 0" class="abgang-tier-eingabe__scans-list">
                <li *ngFor="let tier of tierlisteTiere; trackBy: trackTierByGtId" class="abgang-tier-eingabe__scan-item">
                    <kiene-ohrmarke
                        [ohrmarke]="tier.ohrmarke_notnull || tier.ohrmarke_kurz || tier.ohrmarke15"
                        class="abgang-tier-eingabe__scan-ohrmarke"
                    ></kiene-ohrmarke>
                    <mat-icon class="abgang-tier-eingabe__scan-status abgang-tier-eingabe__scan-status--ok">
                        check_circle
                    </mat-icon>
                    <kiene-gruppe-tier-card
                        class="abgang-tier-eingabe__scan-tier-menu"
                        [tier]="tier"
                        [disableCardClickDetails]="true"
                        [hideAllButtons]="false"
                        [hideBemerkung]="true"
                        [hideReklamationen]="true"
                        [hideKunde]="hideKundeOnScanTierCard"
                        [hideStatusInfos]="true"
                        [hideTranspondernr]="true"
                        [hideGeschlechtRasse]="true"
                        [hideGruppe]="true"
                        [hideAbteil]="true"
                        [hideGewicht]="true"
                        [hideAlter]="true"
                        [hideEinstallungAbgang]="true"
                        [hideAbgang]="true"
                        [hideTodesdatum]="true"
                        [hideGrundEntfernung]="true"
                        (reload)="onScanTierCardReload()"
                    >
                        <ng-container mat-menu-items>
                            <button
                                *ngIf="canRemoveTierFromListe"
                                type="button"
                                mat-menu-item
                                (click)="ausListeEntfernenTier(tier)"
                            >
                                <mat-icon>remove_circle_outline</mat-icon>
                                <span>Tier aus Liste entfernen</span>
                            </button>
                        </ng-container>
                    </kiene-gruppe-tier-card>
                </li>
            </ul>
        </aside>
        </div>
    </div>
</div>
